import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import photoFrame from '../assets/images/PhotoFrame(1).png';
import './Selfie.css';
import toast from 'react-hot-toast';
import Profile from './Profile';
import ProfileService from '../services/Profile';
import { serverAssets } from "../constants/common"
import ScratchReward from '../component/ScratchReward';
import RegistrationService from '../services/registration';
import NoData from '../component/NoData';

const Passport = () => {
    const navigate = useNavigate();
    let personalInfoResponse = useSelector(state => state.userTypeSlice.personalInfoResponse);
    
    const [passport, setPassport] = useState({frontImage: "", backImage: ""});
    const [preview, setPreview] = useState(null);
    const fileInputRef = useRef(null);
        // Handle file upload from device
    
    const streamRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [scratchCardDetails, setScratchCardDetails] = useState(null);

    // const formatDateTime = (date) => {
    //     if (!date) return '';
    //         return new Date(date).toLocaleString('en-IN', {
    //             day: '2-digit',
    //             month: 'short',
    //             year: 'numeric',
    //             hour: 'numeric',
    //             minute: '2-digit',
    //             hour12: true,
    //     });
    // };

    // useEffect(() => {
    //     if (!personalInfoResponse?.response?.message?.selfie_icon || personalInfoResponse?.response?.message?.selfie_icon.length === 0) {
    //         toast.error('Selfie feature is not available for your account');
    //         navigate('/landing');
    //     }
    // }, [personalInfoResponse, navigate]);

    // useEffect(() => {
    //     return () => {
    //         if (streamRef.current) {
    //             streamRef.current.getTracks().forEach(track => track.stop());
    //         }
    //     };
    // }, []);

    useEffect(() => {
        const fetchPassport = async () => {
            try {
                const res = await RegistrationService.adaniPassport()
                if(res.success == true) {
                    setPassport({frontImage: res?.response?.data?.front_image_url, backImage: res?.response?.data?.back_image_url})
                    setLoading(false);
                } else {
                    toast.error(res.response.message);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching passport details:');
                 setLoading(false);
            }
        }
        fetchPassport();
    }, [])

    // let imgUrl = personalInfoResponse?.response?.message?.selfie_icon[0]?.image_url;

    // const statusElement = personalInfoResponse?.response?.message?.selfie_icon[0]?.status;
    //     // statusElement: 1 = approved, 2 = rejected

    

    return (
        <div className="selfie-page">
            <div className="background-decoration">
                <div className="decoration-blob blob-1"></div>
                <div className="decoration-blob blob-2"></div>
                <div className="decoration-blob blob-3"></div>
            </div>
            
            {/* {!imgUrl && 
            <Container className="selfie-container">
                <Row className="align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                    <Col lg={8} md={10} sm={12} className="text-center">
                        <div className="selfie-card">
                            <h1 className="selfie-title">Capture Your Moment</h1>
                            <p className="selfie-subtitle">
                                {cameraActive ? 'Position yourself and click capture' : 'Click start to open camera'}
                            </p>
                            
                            <div className="image-wrapper" style={{display: "block"}}>
                                <canvas ref={canvasRef} style={{ display: 'none' }} />
                                
                                {cameraActive && (
                                    <div className="camera-container">
                                        <video
                                            key="video-stream"
                                            ref={videoRef}
                                            autoPlay={true}
                                            playsInline={true}
                                            muted={true}
                                            className="video-feed"
                                        />
                                        <div className="camera-frame"></div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>} */}
            {!passport.frontImage &&  <Container>
                <Row>
                            <Col>
                <NoData title='No Passport Details Available' /> 
                            </Col>
                    </Row> 

            </Container>}
            {passport.frontImage && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '80vh',
                    width: '100%',
                }}>
                   <div className="selfie-card" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    background: '#fff',
                    padding: '2rem',
                    margin: '2rem 0rem',
                    borderRadius: '20px',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                    maxWidth: '580px',
                    width: '100%',
                    }}>
                        <h1 className="selfie-title" style={{marginBottom: '1rem', textAlign: 'center'}}>Adani Passport</h1>
                        <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            // gap: '16px',
                            padding: '12px',
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #005baa 0%, #00b8d9 40%, #6f42c1 100%)',
                            boxShadow: '0 6px 24px rgba(0,91,170,0.15)',
                            marginBottom: '1.5rem',
                            width: '100%',
                        }}
                        >
                        {/* <p style={{margin: 0, fontWeight: 600}}>Front Side</p> */}
                        {/* <div
                        style={{
                            width: '300px',
                            height: '180px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'hidden',
                        }}
                        >
                        <img
                            src={passport.frontImage}
                            alt="Front"
                            style={{
                            transform: 'rotate(90deg)',
                            height: '100%',
                            objectFit: 'contain',
                            }}
                        />
                        </div> */}
                        <img
                            src={passport.frontImage}
                            alt="Front"
                            style={{
                                transform: 'rotate(90deg)',
                                width: '300px',
                                height: 'auto',
                                objectFit: 'contain',
                              }}
                        />
                        {/* <p style={{margin: 0, fontWeight: 600}}>Back Side</p> */}
                        <img
                            src={passport.backImage}
                            alt="Back"
                            style={{
                                transform: 'rotate(90deg)',
                                width: '300px',
                                height: 'auto',
                                objectFit: 'contain',
                              }}
                        />
                        </div>
                  
                        {/* {!loading && <ScratchReward 
                        imgUrl={imgUrl}
                        rewardText={scratchCardDetails?.scratchMsg}
                        // rewardText={"Congratulations! You've won a reward."}
                        isScratchable={scratchCardDetails?.isScractable}
                        // isScratchable={true}
                        gift_name={scratchCardDetails?.data[0]?.gift_name}
                        selfieId={personalInfoResponse?.response?.message?.selfie_icon[0]?.ad_selfie_config_id}
                        />} */}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Passport;
